import React from "react";
import { FlatList, View } from "react-native";
import { RefreshControl } from "react-native-web-refresh-control";
import Empty from "./Empty";

function ListItems({
  data = [],
  empty = {},
  renderItem = () => {},
  refresh,
  refreshing = false,
  onRefresh = () => {},
}) {
  return (
    <View style={{ flex: 1, paddingHorizontal: 15, paddingVertical: 10 }}>
      <FlatList
        data={data}
        keyExtractor={(_, index) => index + "kl"}
        contentContainerStyle={data.length > 0 ? {} : { flex: 1 }}
        refreshControl={
          refresh ? (
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          ) : null
        }
        ListEmptyComponent={
          <Empty
            iconType={empty.iconType}
            iconName={empty.iconName}
            text={empty.text}
          />
        }
        showsVerticalScrollIndicator={false}
        renderItem={({ item, index }) => renderItem(item, index)}
      />
    </View>
  );
}

export default ListItems;
